// provocação do chefe da região antes da batalha — fixa por fase (mesma fase, mesma fala)
const TAUNTS = {
  abobora: [
    'Volta pra casa, novato. Minha plantação não é lugar pra lata-velha.',
    'Já assustei corvo maior que você.',
    'Cuidado com o vento… ou vai acertar a própria abóbora.',
    'Essa lataria vai virar enfeite no meu espantalho.',
  ],
  fantasma: [
    'Eu já morri uma vez. Você vai morrer hoje.',
    'Atira à vontade — passa direto por mim.',
    'Sinta esse frio? É o seu motor congelando.',
    'Vou assombrar essa sua torre até ela render.',
  ],
  bruxa: [
    'Meu caldeirão pede mais um pedaço de ferro.',
    'O vento obedece a mim, criança.',
    'Vou transformar seu tanque em sapo enferrujado.',
    'Mire o quanto quiser. Eu sopro o tiro de volta.',
  ],
  esqueleto: [
    'Não tenho carne pra doer. Você tem.',
    'Meus ossos já enterraram gente melhor que você.',
    'Cada tiro seu é uma pá na sua própria cova.',
    'Bem-vindo ao cemitério. A vaga é sua.',
  ],
  vampiro: [
    'Você chegou longe. Agora chegou ao fim.',
    'Vou beber o último litro de combustível dessa sucata.',
    'Meu castelo nunca devolveu um visitante.',
    'Ajoelha. A noite é minha.',
  ],
};

export const bossTaunt = (opponent, node) => {
  const lista = TAUNTS[opponent?.id] || TAUNTS.abobora;
  return lista[(Math.max(1, Number(node) || 1) * 7) % lista.length];
};
